/**
 * Torso outfit textures: alien-cosmic-2
 */
import { CANVAS_FONTS } from '../../../../core/fonts.js';
export function drawTorso_ossified_male(ctx, size, _options = {}) {
  // 15. GIÁP KHUNG XƯƠNG HÓA THẠCH NGÀ CỔ RẠN NỨT (OSSUARY-PRIME - MALE)
  ctx.fillStyle = '#1c1917';
  ctx.fillRect(0, 0, size, size);

  // Xương ức trung tâm
  ctx.fillStyle = '#fef3c7';
  ctx.beginPath();
  ctx.moveTo(size * 0.42, size * 0.1);
  ctx.lineTo(size * 0.58, size * 0.1);
  ctx.lineTo(size * 0.56, size * 0.58);
  ctx.lineTo(size * 0.5, size * 0.7);
  ctx.lineTo(size * 0.44, size * 0.58);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = '#78350f';
  ctx.lineWidth = size * 0.016;
  ctx.stroke();

  // 4 cặp xương sườn hóa thạch
  for (let s = 0; s < 4; s++) {
    const ribY = size * (0.18 + s * 0.14);

    ctx.fillStyle = '#fef3c7';
    ctx.beginPath();
    ctx.moveTo(size * 0.42, ribY);
    ctx.quadraticCurveTo(size * 0.2, ribY - size * 0.04, size * 0.1, ribY + size * 0.08);
    ctx.lineTo(size * 0.1, ribY + size * 0.13);
    ctx.quadraticCurveTo(size * 0.22, ribY + size * 0.02, size * 0.42, ribY + size * 0.06);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(size * 0.58, ribY);
    ctx.quadraticCurveTo(size * 0.8, ribY - size * 0.04, size * 0.9, ribY + size * 0.08);
    ctx.lineTo(size * 0.9, ribY + size * 0.13);
    ctx.quadraticCurveTo(size * 0.78, ribY + size * 0.02, size * 0.58, ribY + size * 0.06);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  ctx.strokeStyle = '#92400e';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.14);
  ctx.lineTo(size * 0.48, size * 0.32);
  ctx.lineTo(size * 0.52, size * 0.48);
  ctx.lineTo(size * 0.5, size * 0.65);
  ctx.stroke();

  ctx.fillStyle = '#451a03';
  ctx.fillRect(0, size * 0.82, size, size * 0.1);
  ctx.fillStyle = '#fde68a';
  ctx.fillRect(size * 0.38, size * 0.8, size * 0.24, size * 0.14);
  ctx.strokeStyle = '#78350f';
  ctx.strokeRect(size * 0.38, size * 0.8, size * 0.24, size * 0.14);
}

export function drawTorso_ossified_female(ctx, size, options = {}) {
  // 16. ÁO THẮT ĐAI XƯƠNG CHẠM KHẮC HOA VĂN CỔ (OSSUARY-PRIME - FEMALE)
  ctx.fillStyle = '#44403c';
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.arc(size * 0.5, 0, size * 0.24, 0, Math.PI);
  ctx.fill();

  for (let b = 0; b < 9; b++) {
    const angle = Math.PI * (0.1 + (b / 8) * 0.8);
    const bx = size * 0.5 + Math.cos(angle) * size * 0.26;
    const by = Math.sin(angle) * size * 0.24;
    ctx.fillStyle = '#fef3c7';
    ctx.beginPath();
    ctx.arc(bx, by, size * 0.024, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = '#78350f';
    ctx.lineWidth = size * 0.008;
    ctx.stroke();
  }

  ctx.strokeStyle = '#fde68a';
  ctx.lineWidth = size * 0.018;
  for (let s = 0; s < 3; s++) {
    const sy = size * (0.32 + s * 0.1);
    ctx.beginPath();
    ctx.moveTo(size * 0.22, sy);
    ctx.quadraticCurveTo(size * 0.5, sy + size * 0.06, size * 0.78, sy);
    ctx.stroke();
  }

  ctx.fillStyle = '#fef3c7';
  ctx.fillRect(size * 0.15, size * 0.65, size * 0.7, size * 0.22);
  ctx.strokeStyle = '#78350f';
  ctx.lineWidth = size * 0.02;
  ctx.strokeRect(size * 0.15, size * 0.65, size * 0.7, size * 0.22);

  ctx.strokeStyle = '#991b1b';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.26, size * 0.69);
  ctx.lineTo(size * 0.32, size * 0.83);
  ctx.moveTo(size * 0.24, size * 0.76);
  ctx.lineTo(size * 0.34, size * 0.76);
  ctx.stroke();

  ctx.fillStyle = '#b45309';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.76, size * 0.045, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#991b1b';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.74, size * 0.69);
  ctx.lineTo(size * 0.68, size * 0.83);
  ctx.moveTo(size * 0.76, size * 0.76);
  ctx.lineTo(size * 0.66, size * 0.76);
  ctx.stroke();
}

export function drawTorso_quantum_male(ctx, size, _options = {}) {
  // 17. ÁO THÁM HIỂM VŨ TRỤ CÔNG NGHỆ CAO CÓ VAN ÁP SUẤT VÀ MẠCH LƯỢNG TỬ (QUANTUM-X - MALE)
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = '#334155';
  ctx.fillRect(0, 0, size, size * 0.15);
  ctx.fillRect(size * 0.12, size * 0.2, size * 0.35, size * 0.4);
  ctx.strokeStyle = '#64748b';
  ctx.lineWidth = size * 0.015;
  ctx.strokeRect(size * 0.12, size * 0.2, size * 0.35, size * 0.4);

  // Van áp suất lượng tử
  const vX = size * 0.72,
    vY = size * 0.38,
    vR = size * 0.14;
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.arc(vX, vY, vR, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#94a3b8';
  ctx.lineWidth = size * 0.022;
  ctx.stroke();

  ctx.fillStyle = '#0284c7';
  ctx.beginPath();
  ctx.arc(vX, vY, vR * 0.65, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#22c55e';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(vX, vY);
  ctx.lineTo(vX + vR * 0.45, vY - vR * 0.35);
  ctx.stroke();

  // Mạch lượng tử
  ctx.strokeStyle = '#22c55e';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.28);
  ctx.lineTo(size * 0.4, size * 0.28);
  ctx.lineTo(size * 0.4, size * 0.52);
  ctx.lineTo(size * 0.25, size * 0.52);
  ctx.moveTo(size * 0.3, size * 0.4);
  ctx.lineTo(size * 0.38, size * 0.4);
  ctx.stroke();

  ctx.fillStyle = '#86efac';
  [
    [0.2, 0.28],
    [0.4, 0.28],
    [0.4, 0.52],
    [0.25, 0.52]
  ].forEach((pt) => {
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  });

  // Đai áp suất
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, size * 0.76, size, size * 0.14);
  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = size * 0.012;
  ctx.strokeRect(0, size * 0.76, size, size * 0.14);
  ctx.fillStyle = '#e2e8f0';
  ctx.fillRect(size * 0.42, size * 0.78, size * 0.16, size * 0.1);
}

export function drawTorso_quantum_female(ctx, size, _options = {}) {
  // 18. BỘ ĐỒ PHI HÀNH KHÔNG GIAN GỌN GÀNG (QUANTUM-X - FEMALE)
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.moveTo(0, size * 0.18);
  ctx.lineTo(size * 0.16, size * 0.22);
  ctx.lineTo(size * 0.18, size * 0.85);
  ctx.lineTo(0, size * 0.85);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.moveTo(size, size * 0.18);
  ctx.lineTo(size * 0.84, size * 0.22);
  ctx.lineTo(size * 0.82, size * 0.85);
  ctx.lineTo(size, size * 0.85);
  ctx.closePath();
  ctx.fill();

  // Khóa kéo áp suất cam
  ctx.fillStyle = '#f97316';
  ctx.fillRect(size * 0.485, 0, size * 0.03, size);

  // Cổ áo phi hành
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(size * 0.32, 0, size * 0.36, size * 0.12);
  ctx.strokeStyle = '#f97316';
  ctx.lineWidth = size * 0.015;
  ctx.strokeRect(size * 0.32, 0, size * 0.36, size * 0.12);

  // Huy hiệu Quantum-X
  ctx.fillStyle = '#2563eb';
  ctx.beginPath();
  ctx.arc(size * 0.28, size * 0.32, size * 0.065, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.font = `bold ${size * 0.06}px ${CANVAS_FONTS.sans}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('Q', size * 0.28, size * 0.32);

  // Đai thắt lưng
  ctx.fillStyle = '#334155';
  ctx.fillRect(0, size * 0.68, size, size * 0.08);
  ctx.fillStyle = '#06b6d4';
  ctx.fillRect(size * 0.44, size * 0.69, size * 0.12, size * 0.06);
}

export function drawTorso_drakonis_male(ctx, size, _options = {}) {
  // 19. ÁO VẢY RỒNG LỤC GIÁC NỔI KHỐI ĐAN LỚP VIỀN ĐỎ THẪM (DRAKONIS - MALE)
  ctx.fillStyle = '#450a0a';
  ctx.fillRect(0, 0, size, size);

  // Giáp ức rồng
  ctx.fillStyle = '#7f1d1d';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.65, 0);
  ctx.lineTo(size * 0.7, size * 0.55);
  ctx.lineTo(size * 0.5, size * 0.75);
  ctx.lineTo(size * 0.3, size * 0.55);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = '#b91c1c';
  ctx.lineWidth = size * 0.02;
  ctx.stroke();

  // Mạng lưới vảy rồng lục giác
  const hexR = size * 0.065;
  const drawHex = (hx, hy) => {
    ctx.fillStyle = '#991b1b';
    ctx.beginPath();
    for (let i = 0; i < 6; i++) {
      const a = (i * Math.PI) / 3;
      const x = hx + Math.cos(a) * hexR;
      const y = hy + Math.sin(a) * hexR;
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = '#450a0a';
    ctx.lineWidth = size * 0.014;
    ctx.stroke();

    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = size * 0.008;
    ctx.beginPath();
    ctx.moveTo(hx - hexR * 0.8, hy - hexR * 0.4);
    ctx.lineTo(hx, hy - hexR * 0.9);
    ctx.lineTo(hx + hexR * 0.8, hy - hexR * 0.4);
    ctx.stroke();
  };

  for (let r = 0; r < 4; r++) {
    const hy = size * (0.2 + r * 0.16);
    const ox = r % 2 === 0 ? 0 : hexR * 0.85;
    drawHex(size * 0.16 + ox, hy);
    drawHex(size * 0.84 - ox, hy);
    if (r >= 2) {
      drawHex(size * 0.5, hy + size * 0.15);
    }
  }

  ctx.fillStyle = '#78350f';
  ctx.fillRect(0, size * 0.84, size, size * 0.12);
  ctx.fillStyle = '#f59e0b';
  ctx.fillRect(size * 0.4, size * 0.82, size * 0.2, size * 0.16);
  ctx.fillStyle = '#b91c1c';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.9, size * 0.05, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_drakonis_female(ctx, size, _options = {}) {
  // 20. ÁO GẤM VẢY RỒNG CỔ CAO THANH NHÃ (DRAKONIS - FEMALE)
  const silkDrakGrad = ctx.createLinearGradient(0, 0, 0, size);
  silkDrakGrad.addColorStop(0, '#881337');
  silkDrakGrad.addColorStop(0.6, '#9f1239');
  silkDrakGrad.addColorStop(1, '#4c0519');
  ctx.fillStyle = silkDrakGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cao cung đình
  ctx.fillStyle = '#881337';
  ctx.fillRect(size * 0.35, 0, size * 0.3, size * 0.14);
  ctx.strokeStyle = '#fbbf24';
  ctx.lineWidth = size * 0.02;
  ctx.strokeRect(size * 0.35, 0, size * 0.3, size * 0.14);

  // Vạt áo chéo viền vàng
  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.018;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.14);
  ctx.quadraticCurveTo(size * 0.65, size * 0.35, size * 0.78, size * 0.6);
  ctx.stroke();

  // Vân vảy rồng dệt tơ vàng
  ctx.strokeStyle = 'rgba(251, 191, 36, 0.45)';
  ctx.lineWidth = size * 0.012;
  for (let w = 0; w < 5; w++) {
    const wy = size * (0.25 + w * 0.1);
    ctx.beginPath();
    for (let x = size * 0.15; x <= size * 0.85; x += size * 0.14) {
      ctx.arc(x, wy, size * 0.065, 0, Math.PI);
    }
    ctx.stroke();
  }

  // Đai ngọc long châu
  ctx.fillStyle = '#b45309';
  ctx.fillRect(0, size * 0.68, size, size * 0.09);
  ctx.fillStyle = '#fbbf24';
  ctx.fillRect(0, size * 0.68, size, size * 0.015);
  ctx.fillRect(0, size * 0.755, size, size * 0.015);

  ctx.fillStyle = '#10b981';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.725, size * 0.05, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#fbbf24';
  ctx.lineWidth = size * 0.012;
  ctx.stroke();
}

export const alien_cosmic_2_drawers = {
  ossified_male: drawTorso_ossified_male,
  ossified_female: drawTorso_ossified_female,
  quantum_male: drawTorso_quantum_male,
  quantum_female: drawTorso_quantum_female,
  drakonis_male: drawTorso_drakonis_male,
  drakonis_female: drawTorso_drakonis_female
};
